var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"overlay-page-link",class:[
    `overlay-page-link--${_vm.type}`,
    { 'read-more': _vm.type === 'read-more' },
  ],attrs:{"href":"#"},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }